module.exports = __webpack_public_path__ + "5516e7999a83b7fba528a9a1709099bf.svg";